import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

export const homeroutes: Routes = [
  {
    path: '', loadComponent: () => import('./home.component').then(m => m.HomeComponent), canActivate: [MsalGuard],

    children: [
      { path: 'unauthorized-access', loadComponent: () => import('./unauthorized-access/unauthorized-access.component').then((m) => m.UnauthorizedAccessComponent) },
    ],
  },
  { path: 'admin', loadComponent: () => import('./admin/admin.component').then((m) => m.AdminComponent) },
  { path: 'donation', loadComponent: () => import('./donation/donation.component').then((m) => m.DonationComponent) },
  { path: 'session-timeout', loadComponent: () => import('./session-timeout/session-timeout.component').then((m) => m.SessionTimeoutComponent) },
];
